import {SC_GenericFile} from "./SC_GenericFile";
import {SC_SubFileType} from "./SC_SubFileType";

// @ts-ignore
export class SC_SubcontractorFile extends SC_GenericFile {
    /**
     * Input property name constants for fromAPI
     */
    static readonly inputKeys = {
        startDate: 'startDate',
        endDate: 'endDate',
        type: 'type',
        active: 'active'
    };

    startDate: Date | null;
    endDate: Date | null;
    type: SC_SubFileType;
    active: boolean | null;

    constructor({
        startDate = null,
        endDate = null,
        type = new SC_SubFileType(SC_SubFileType.NULL),
        active = null,
        props = {},
    } = {}) {
        super({...props});

        this.startDate = startDate;
        this.endDate = endDate;
        this.type = type;
        this.active = active;
    }

    static fromAPI(jsonin: Record<string, any>): SC_SubcontractorFile {
        return new SC_SubcontractorFile({
            startDate: jsonin[SC_SubcontractorFile.inputKeys.startDate] ? new Date(jsonin[SC_SubcontractorFile.inputKeys.startDate]) : null,
            endDate: jsonin[SC_SubcontractorFile.inputKeys.endDate] ? new Date(jsonin[SC_SubcontractorFile.inputKeys.endDate]) : null,
            type: SC_SubFileType.fromAPI(jsonin[SC_SubcontractorFile.inputKeys.type] ?? SC_SubFileType.NULL),
            active: jsonin[SC_SubcontractorFile.inputKeys.active] ?? null,
            props: SC_GenericFile.basicAPIStuff(jsonin),
        });
    }

    static fromAPIArray(jsoninarr: Array<Record<string, unknown>>): SC_SubcontractorFile[] {
        return jsoninarr?.map(jsonin => SC_SubcontractorFile.fromAPI(jsonin)) ?? [];
    }

    clone(): SC_SubcontractorFile {
        const cloned = new SC_SubcontractorFile();

        cloned._clone(this);

        cloned.active = this.active;
        cloned.startDate = this.startDate;
        cloned.endDate = this.endDate;
        cloned.type = this.type.clone();

        return cloned;
    }

    /**
     * Merges another SC_WorkorderReport object into this one, replacing null fields
     */
    merge(other: SC_SubcontractorFile): SC_SubcontractorFile {
        super.merge(other);

        return this;
    }
}
